import { Button, Tooltip } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import React, { FunctionComponent } from 'react';
import { useVideoContext } from '../../../../hooks/use-video';
import { useTranslation } from 'react-i18next';

interface Props {
  sceneId?: string;
}

const ReplayScene: FunctionComponent<Props> = ({ sceneId }) => {
  const { t } = useTranslation();
  const { selectedScene, movePlayerToFrame, getSceneStartFrame } =
    useVideoContext();

  const replayScene = () => {
    const currentSceneId = sceneId || selectedScene?._id;

    if (currentSceneId) {
      const startFrame = getSceneStartFrame(currentSceneId);
      movePlayerToFrame(startFrame);
    }
  };

  return (
    <Tooltip placement={'right'} title={t('videoEditor.scene.replayScene')}>
      <Button
        onClick={() => replayScene()}
        type={'text'}
        icon={
          <PlayCircleOutlined style={{ marginTop: '2px', fontSize: '18px' }} />
        }
      />
    </Tooltip>
  );
};

export default ReplayScene;
